import React, { useEffect, useState } from "react";
import { ref, get, set } from "firebase/database";
import { db } from "../../lib/firebase";
import "./CardConfig.css";

export default function CardConfig() {
  const [cfg, setCfg] = useState({
    showTitle: true,
    showDescription: true,
    showButton: true,
    buttonName: "Learn More",
    buttonLink: "/contact",
    backgroundColor: "#ffffff",
    shadow: "0 2px 6px rgba(0,0,0,0.15)",
    mediaType: "image", // image or video
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // Load existing config
  useEffect(() => {
    (async () => {
      try {
        const snap = await get(ref(db, "cardconfig"));
        if (snap.exists()) setCfg((prev) => ({ ...prev, ...snap.val() }));
      } catch (e) {
        setError("Failed to load configuration");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChange = (field, value) =>
    setCfg((prev) => ({ ...prev, [field]: value }));

  const saveConfig = async () => {
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      await set(ref(db, "cardconfig"), cfg);
      setSuccess("Saved successfully ✔");
    } catch (e) {
      setError("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="cardcfg-loading">Loading…</div>;

  // Default media previews
// Default media previews (top of your CardConfig.jsx)
const defaultImage =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80";
const defaultVideo =
  "https://cdn.videvo.net/videvo_files/video/free/2013-08/small_watermarked/hd0931_preview.webm";


  return (
    <section className="cardcfg-wrap">
      <h2 className="cardcfg-title">Card Configuration</h2>

      {success && <p className="success">{success}</p>}
      {error && <p className="error">{error}</p>}

      <div className="cardcfg-form">
        <div className="row">
          <label>
            <input
              type="checkbox"
              checked={cfg.showTitle}
              onChange={(e) => handleChange("showTitle", e.target.checked)}
            />{" "}
            Show Title
          </label>

          <label>
            <input
              type="checkbox"
              checked={cfg.showDescription}
              onChange={(e) => handleChange("showDescription", e.target.checked)}
            />{" "}
            Show Description
          </label>

          <label>
            <input
              type="checkbox"
              checked={cfg.showButton}
              onChange={(e) => handleChange("showButton", e.target.checked)}
            />{" "}
            Show Button
          </label>
        </div>

        <div className="row">
          <label className="label">Media Type</label>
          <select
            value={cfg.mediaType}
            onChange={(e) => handleChange("mediaType", e.target.value)}
          >
            <option value="image">Image</option>
            <option value="video">Video</option>
          </select>
        </div>

        <div className="row">
          <label className="label">Button Name</label>
          <input
            type="text"
            value={cfg.buttonName}
            onChange={(e) => handleChange("buttonName", e.target.value)}
          />
        </div>

        <div className="row">
          <label className="label">Button Link</label>
          <input
            type="text"
            value={cfg.buttonLink}
            onChange={(e) => handleChange("buttonLink", e.target.value)}
          />
        </div>

        <div className="row">
          <label className="label">Background Color</label>
          <input
            type="color"
            value={cfg.backgroundColor}
            onChange={(e) => handleChange("backgroundColor", e.target.value)}
          />
        </div>

        <div className="row">
          <label className="label">Box Shadow</label>
          <input
            type="text"
            value={cfg.shadow}
            onChange={(e) => handleChange("shadow", e.target.value)}
            placeholder="0 2px 6px rgba(0,0,0,0.15)"
          />
        </div>

        <div className="actions">
          <button onClick={saveConfig} disabled={saving}>
            {saving ? "Saving…" : "Save to Firebase"}
          </button>
        </div>
      </div>

      <h3 className="preview-title">Live Preview</h3>
      <div
        className="cardcfg-preview"
        style={{
          background: cfg.backgroundColor,
          boxShadow: cfg.shadow,
        }}
      >
        {cfg.mediaType === "image" ? (
          <img src={defaultImage} alt="preview" className="preview-media" />
        ) : (
          <video
            src={defaultVideo}
            className="preview-media"
            autoPlay
            loop
            muted
          />
        )}

        {cfg.showTitle && <h4 className="preview-heading">Sample Card Title</h4>}
        {cfg.showDescription && (
          <p className="preview-desc">
            This is an example description to preview how the text looks.
          </p>
        )}

        {cfg.showButton && (
          <a href={cfg.buttonLink} className="preview-btn">
            {cfg.buttonName}
          </a>
        )}
      </div>
    </section>
  );
}
